    <template>  
    <div>
        <form class="contact-form" method="POST" :action="action" @submit="onSubmit" ref="form" v-if="!messageSent">
            <div class="md-card md-theme-default">
                <div class="md-card-content">
                    <div class="form-row">
                        <md-field v-bind:class="{'md-invalid': !!errors['name']}">
                            <label>{{ $t('contact.name') }}</label>
                            <md-input type="text" name="name" v-model="formData['name']" required></md-input>
                            <span class="md-error">{{ errors['name'] ? errors['name'][0] : '' }}</span>
                        </md-field>
                        <md-field v-bind:class="{'md-invalid': !!errors['email']}">
                            <label>{{ $t('contact.email') }}</label>
                            <md-input type="text" name="email" v-model="formData['email']" required></md-input>
                            <span class="md-error">{{ errors['email'] ? errors['email'][0] : '' }}</span>
                        </md-field>
                        <phone-field required name="phone" v-model="formData['phone']" :errors="errors['phone']" :label="$t('contact.phone')" :country-id="countryId" ref="phoneInput" :disabled="submitting ? 'disabled' : null" dusk="phone_country_FR"></phone-field>
                    </div>
                    <div class="form-row">
                        <md-field v-bind:class="{'md-invalid': !!errors['body']}">
                            <label>{{ $t('contact.body') }}</label>
                            <md-textarea name="body" rows="10" v-model="formData['body']" required></md-textarea>
                            <span class="md-error">{{ errors['body'] ? errors['body'][0] : '' }}</span>
                        </md-field>
                    </div>
                </div>
                <div class="md-card-actions md-alignment-right">
                    <submit-button type="submit" :label="$t('contact.submit')" @click="onSubmit" :submitting="submitting" dusk="submit-contact"></submit-button>
                </div>
            </div>
        </form>

        <div v-if="messageSent" class="message-sent-container">
            <div v-html="$t('contact.message-sent')"></div>
            <md-button :href="continueUrl" class="md-button md-raised md-primary md-theme-default">{{ $t('contact.continue') }}</md-button>
        </div>
    </div>
</template>

<script>
import PhoneField from './widgets/PhoneFieldComponent.vue';

export default {
    components: {
        PhoneField,
    },
    props: {
        action: String,
        countryId: String,
        continueUrl: String,
    },
    data() {
        return {
            submitting: false,
            formData: {
                name: '',
                email: '',
                phone: '',
                body: '',
            },
            errors: {
                name: null,
                email: null,
                phone: null,
                body: null,
            },
            messageSent: false
        }
    },
    methods: {
        onSubmit(event) {
            if (event) {
                event.preventDefault();
            }
            for (var i of Object.keys(this.errors)) {
                this.errors[i] = null;
            }
            this.submitting = true;
            axios.post(this.$refs.form.action, this.formData)
                .then((response) => {
                    this.submitting = false;
                    for (var i of Object.keys(this.formData)) {
                        this.formData[i] = '';
                    }
                    this.messageSent = true;
                    if (window.ga) {
                        window.ga('send', 'event', {
                            eventCategory: 'Contact Form',
                            eventAction: 'submit',
                        });
                    }
                }).catch((error) => {
                    this.submitting = false;
                    for (var i of Object.keys(this.errors)) {
                        this.errors[i] = error.response.data.errors[i];
                    }
                });
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/ContactFormComponent.vue